import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { PanelGrid } from './PanelGrid'
import { StoryContent } from './StoryContent'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

const StyledArticle = styled.article`
  height: 450px;
  display: flex;
  flex-direction: column;
`

const StyledStoryContent = styled(StoryContent)`
  flex: 1;
  overflow-y: auto;
  margin-bottom: 1rem;
`

/** container to display stories in a panel grid */
const StoryGrid = ({ stories, pathname, draggable, onDragEnd }) => (
  <section aria-label='Stories'>
    <PanelGrid
      className='story-grid'
      items={stories}
      renderItem={(story) => {
        const onKeyDown = (event) => event.stopPropagation()
        return (
          <StyledArticle onKeyDown={onKeyDown}>
            <header>
              <h2 className='mb-'>{story.title}</h2>
            </header>
            <StyledStoryContent content={story.content} />
            <footer>
              <Button
                as={Link}
                to={pathname + '/' + story.id}
                variant='outline-secondary'
                aria-label={`Open Story Details: ${story.title}`}
              >
                Open Story Details
              </Button>
            </footer>
          </StyledArticle>
        )
      }}
      draggable={draggable}
      onDragEnd={onDragEnd}
    />
  </section>
)

StoryGrid.propTypes = {
  /** the stories to display */
  stories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      content: PropTypes.string.isRequired
    })
  ),
  /** the path to the story */
  pathname: PropTypes.string.isRequired,
  /** is drag and drop allowed */
  draggable: PropTypes.bool,
  /** handler for drag end action */
  onDragEnd: PropTypes.func
}

export { StoryGrid }
